import React, { useState, useEffect, useRef } from "react";
import "../common/styles/styles.css";
import Grid from "@mui/material/Grid";

import "bootstrap/dist/css/bootstrap.min.css";
import { styled } from "@mui/material/styles";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { Providers, ProviderState } from "@microsoft/mgt-element";
import Select from "react-select";
import Modal from "../common/modal/Modal";
import Alert from "@mui/joy/Alert";
import CircularProgress from "@mui/joy/CircularProgress";
import Stack from "@mui/joy/Stack";

import Warning from "@mui/icons-material/Warning";

import IconButton from "@mui/joy/IconButton";
import Check from "@mui/icons-material/Check";
import AspectRatio from "@mui/joy/AspectRatio";
import LinearProgress from "@mui/joy/LinearProgress";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Paper from "@mui/material/Paper"; //Used to divide the page into 2 columns and improve UI effect of background of an application
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import parse from "autosuggest-highlight/parse";
import match from "autosuggest-highlight/match";
import {
  Box,
  Tabs,
  Tab,
  Checkbox,
  Button,
  Typography,
  Card,
  CardContent,
} from "@mui/material";

//Set theme properties for the screen reader
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark" ? "#009de0 !important" : "#009de0",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "left",
  color: "white",
  boxShadow: "none",
  fontFamily: "GothamRounded-Book",
}));

const Projectrestriction = ({
  prevStep,
  values,
  pbuDetail,
  vgrpDetail,
  radiovalue,
  setRadiovalue,
  setSearchVal,
  searchVal,
  projAsis,
  projMem,
  vgrpVal,
  pbuVal,
  onSave,
}) => {
  // Create variables for the screen reader
  // eslint-disable-next-line
  const [selectedPBUValue, setSelectedPBUValue] = useState("");
  const isAuthenticated = useIsAuthenticated();
  const { inProgress } = useMsal();
  const pplrefPjMem = useRef();
  const pplrefPjAsis = useRef();
  const vrgpref = useRef();
  const autoCompleteSearch = useRef();
  const { instance, accounts } = useMsal();
  const [projAsisDetail, setprojAsisDetail] = useState([]);
  const [projMemDetail, setprojMemDetail] = useState([]);
  const [selectedProjMem, setSelectedProjMem] = useState(projMem || []); // State for selected values
  const [isWarn, setisWarn] = useState(false);
  const [isWarnMsg, setisWarnMsg] = useState("");
  const [isInfo, setisInfo] = useState(false);  
  const [isInfoMsg, setInfoMsg] = useState("");
  const [isSuccess, setisSuccess] = useState(false);
  const [loadAllMdata, setLoadAllMetadata] = useState([]);
  const loadAllMdatas = [];
  const [isSuccessMsg, setisSuccessMsg] = useState("");
  const [isLoading, setisLoading] = useState(false);
  //const [checkedItems, setCheckedItems] = useState(new Set(selectedValues));
  const [textValue, setTextValue] = useState("");
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const [tabValue, setTabValue] = useState(0);
  // const [isConfidential, setIsConfidential] = useState("");
  // const [isUKProject, setIsUKProject] = useState("");

  const [isConfidential, setIsConfidential] = useState(values?.confidential ?? false);
  const [isUKProject, setIsUKProject] = useState(values?.dataResidency === "UK");
  const confidValidationMsg = "Changing the Confidentiality option to 'Yes' will remove the already selected Viewer group options and will make the field disabled. On changing back to 'No' will enable Viewer Group again.";
  const geography = values.geo;
  

  let curentUserId = "";
  const accessTokenRequestGraphAPI = {
    scopes: [process.env.REACT_APP_GRAPH_SCOPES],
    account: accounts[0],
  };

  // get all viwers group from DB
  const tokenType = process.env.REACT_APP_TOKENTYPE;

  //Authentication options for API requests
  const accessTokenRequest = {
    scopes: [process.env.REACT_APP_SCOPES],
    account: accounts[0],
  };

  useEffect(() => {
  if (values) {
    setIsConfidential(values.confidential ?? false);
    setIsUKProject(values.dataResidency === "UK");
  }
}, [values]);



  async function getCurrentUserId() {
    await instance
      .acquireTokenSilent(accessTokenRequestGraphAPI)
      .then((accessTokenResponse) => {
        //Acquire token silent success
        let accessToken = accessTokenResponse.accessToken;
        //Call your API with token
        const headers = {
          Authorization: process.env.REACT_APP_TOKENTYPE + accessToken,
        };
        fetch("https://graph.microsoft.com/v1.0/me?$select=id", { headers })
          .then(function (response) {
            return response.json();
          })
          .then((currUserResp) => {
            curentUserId = currUserResp.id;
          })
          .catch((err) => {
            console.log(err);
          });
      });
  }

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
    console.log(newValue);
  };

  const handleSave = () => {
    onSave(isConfidential, isUKProject);
  };

  //Handles event for back button selection
  const Previous = (e) => {
    e.preventDefault();
    prevStep();
   // setIsConfidential(false);
   // setIsUKProject(false);
  };

  //handle close event handler for alert
  const handleCloseWarn = () => {
    setisWarn(false);
    setisWarnMsg("");
  };
  const handleCloseSuccess = () => {
    setisSuccess(false);
    setisSuccessMsg("");
    window.location.replace(process.env.REACT_APP_REDIRECT_URI);
  };
  const handleCloseFileyProject = () =>{
    setisInfo(false);
    setInfoMsg("");
  }
  //Handle event for submitting data form from
  const handleSubmit = (event) => {
    let dtesident = "";
    if(isUKProject == true)
      {
        dtesident = "UK";
      }    
      else {
        dtesident = "";
      }
    setisLoading(true);
    getCurrentUserId();
    let accessToken;
    let confidentialvalue = isConfidential;
    let vrgpStr = "";
    values.macNo =
      values.macNo === "No information available yet" ? "" : values.macNo;
    values.crmNo =
      values.crmNo === "No information available yet" ? "" : values.crmNo;
    const curentDateTime = new Date().toISOString().replace("Z", "");
    let projUsersArr = [];
    if (projAsis.length > 0) {
      for (
        let projAsiscount = 0;
        projAsiscount < projAsis.length;
        projAsiscount++
      ) {
        projUsersArr.push({
          roleName: "Project Assistant",
          displayName: projAsis[projAsiscount].value.split("|")[0],
          loginName: projAsis[projAsiscount].value.split("|")[1],
          email: projAsis[projAsiscount].value.split("|")[1],
          aDid: projAsis[projAsiscount].value.split("|")[2],
        });
      }
    }
    if (projMem.length > 0) {
      for (
        let projMemcount = 0;
        projMemcount < projMem.length;
        projMemcount++
      ) {
        projUsersArr.push({
          roleName: "Project Member",
          displayName: projMem[projMemcount].value.split("|")[0],
          loginName: projMem[projMemcount].value.split("|")[1],
          email: projMem[projMemcount].value.split("|")[1],
          aDid: projMem[projMemcount].value.split("|")[2],
        });
      }
    }

    if (values.pjManDet !== "") {
      projUsersArr.push({
        roleName: "Project Manager",
        displayName: values.pjManDet.split("|")[0],
        loginName: values.pjManDet.split("|")[1],
        email: values.pjManDet.split("|")[1],
        aDid: values.pjManDet.split("|")[2],
      });
    }
    if (values.pjOwnDet !== "") {
      projUsersArr.push({
        roleName: "Project Owner",
        displayName: values.pjOwnDet.split("|")[0],
        loginName: values.pjOwnDet.split("|")[1],
        email: values.pjOwnDet.split("|")[1],
        aDid: values.pjOwnDet.split("|")[2],
      });
    }
    if (vgrpVal.length > 0) {
      for (
        let vgrpValcount = 0;
        vgrpValcount < vgrpVal.length;
        vgrpValcount++
      ) {
        vrgpStr += vgrpVal[vgrpValcount].id + ",";
      }
      vrgpStr = vrgpStr.substring(0, vrgpStr.length - 1);
    }
    instance
      .acquireTokenSilent(accessTokenRequest)
      .then((accessTokenResponse) => {
        //Acquire token silent success
        accessToken = accessTokenResponse.accessToken;
        // Call your API with token
        const headers = { Authorization: tokenType + accessToken };

        fetch(process.env.REACT_APP_API_GETUNIQUEID + values.pbu, { headers })
          .then(function (response) {
            return response.json();
          })
          .then((fileryidresp) => {
            if (fileryidresp.message === "Success") {
              values.fileryId = fileryidresp.data[0].fileryId;
              console.log(values.fileryId);
              //Create varaiable to send for POST requests
              const saveMetadata = {
                uniqueID: values.fileryId,
                projectName_English: values.prnameEng,
                projectName: values.prname,
                maconomyProjectID: values.macNo,
                crmProjectID: values.crmNo,
                clientName: values.client,
                departmentNo: values.resDeptNo,
                departmentName: values.resDeptName,
                departmentCode: values.resDeptCode,
                pbu: values.pbu,
                pbuDescription: values.pbuDescription,
                market: values.mar,
                geography: values.geo,
                confidential: confidentialvalue,
                buildingBlockID: pbuVal[0].value,
                datasourceName: null,              
                projectCreationDate: curentDateTime,               
                fileryURL: "/",
                streamID: values.streamId,
                clientID: values.clientID,
                projectStage: values.prstage,
                expectedProjectStartDate: values.expectedProjectStartDate,
                expectedProjectEndDate: values.expectedProjectEndDate,
                projectLevelRating: values.projectLevelRating,
                submittalType: values.submitaltype,               
                projectCreatedFrom: values.projectCreatedFrom,              
                created_By: curentUserId,
                modified_On: null,
                modified_By: null,
                projectUsers: JSON.parse(JSON.stringify(projUsersArr)),
                viewerGroupList: vrgpStr,
                dataResidency: dtesident,
              };

              const inputContent = {
                method: "POST",
                headers: {
                  Authorization: tokenType + accessToken,
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(saveMetadata),
              };

              fetch(process.env.REACT_APP_API_SAVEMETADATA, inputContent)
                .then(function (response) {
                  return response.json();
                })
                .then((metadataresp) => {
                  console.log(metadataresp.message);
                  if (metadataresp.message === "Success") {                    
                    setisLoading(false);
                    setisSuccess(true);
                    setisSuccessMsg(
                      process.env.REACT_APP_SUCCESSMSG_PROJECTCREATED
                    );                   
                  } else {
                    setisLoading(false);
                    setisWarn(true);
                    setisWarnMsg(
                      process.env
                        .REACT_APP_WARNINGMSG_ERROROCCURRED_SAVEMETADATA
                    );
                  }
                });
            } else {
              setisLoading(false);
              setisWarn(true);
              setisWarnMsg(
                process.env.REACT_APP_WARNINGMSG_ERROROCCURRED_FILERYID
              );
            }
          })
          .catch((err) => {
            console.log(err);
            setisLoading(false);
            setisWarn(true);
            setisWarnMsg(process.env.REACT_APP_WARNINGMSG_ERROROCCURRED);
          });
      });
  };


  //UI elements that render  the page and components
  return (
    <div>
      <Box>
        <Grid container>
          <Grid item xs={12}>
            <Box
              style={{ paddingBottom: "2%" }}
              sx={{
                display: "flex",
                //justifyContent: "start",
                m: 1,
                p: 1,
                fontSize: "25px",
                fontFamily: "GothamRounded-Medium !important",
              }}
            >
              {"Client Requirements"}
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "space-between",
                alignItems: "flex-start",
                width: "100%",
                boxSizing: "border-box",
                padding: "0 2%", // reduce padding to avoid overflow
                gap: "1rem",
              }}
            >
              {/* Left Panel */}
              <div style={{ flexBasis: "48%", flexGrow: 1 }}>
                <Item>
                  <div className="userDescriptions">
                    <p>
                      To provide input for any project level restriction.
                      <br />
                      <br />
                      <strong>Note:</strong> It is assumed that either you are
                      taking these decisions as Project Manager or these
                      decisions have been discussed and agreed with your Project
                      Manager.
                    </p>
                  </div>
                </Item>
              </div>

              {/* Right Panel - Tabbed Content */}
              <div
                style={{
                  flexBasis: "48%",
                  flexGrow: 1,
                  backgroundColor: "#009de0 !important",
                  color: "white",               
                  margin: "auto",
                  width: "53%",
                  height: "100vh",
                  right: 0,
                  overflowY: "auto",
                  top: 65,
                  minWidth: "0%",
                }}
              >
                <Card sx={{ mt: 2 }}>
                  <CardContent>
                    <Tabs
                      value={tabValue}
                      onChange={handleChange}
                      textColor="primary"
                      indicatorColor="primary"
                    >
                      <Tab label="Confidentiality" />
                      { geography?.toLowerCase() === "united kingdom" || geography?.toLowerCase() === "uk" ? (
                       <Tab label="Data Residency" />
                         ):null }
                    </Tabs>

                    {tabValue === 0 && (
                      <Card sx={{ mt: 2 }}>
                        <CardContent>
                          <Typography variant="body2">
                            <strong>Is project Confidential?</strong>
                            <Checkbox
                              checked={isConfidential}
                              onChange={(e) => {
                                if(e.target.checked){
                                setisInfo(true);
                                setInfoMsg(confidValidationMsg);
                                vgrpVal.splice(0, vgrpVal.length);
                                }
                                setIsConfidential(e.target.checked);
                              }
                              }
                            />{" "}
                            <strong>Yes</strong>
                            <br />
                            A Confidential project will only be visible to the
                            users and groups that are used in the Filery
                            settings tab.
                            <br />
                            Confidential projects will be accessible by IT
                            Administrators for technical support reasons.
                          </Typography>
                        </CardContent>
                      </Card>
                    )}

                    {tabValue === 1 && (
                      <Card sx={{ mt: 2 }}>
                        <CardContent>
                          <Typography variant="body2">
                            <strong>
                              Does this project have data residency requirement
                              for UK?
                            </strong>
                            <Checkbox
                              checked={isUKProject}
                              onChange={(e) => setIsUKProject(e.target.checked)}
                            />{" "}
                            <strong>Yes</strong>
                            <br />
                            This project has data residency requirements and
                            should be located in the UK local datasource.
                            <br />
                            There are data restrictions for IT administrators
                            accessing outside the UK.
                          </Typography>
                        </CardContent>
                      </Card>
                    )}
                  </CardContent>
                </Card>
              </div>
            </Box>
          </Grid>
          <div className="metadata-container">
            <div className="button-container">
              <div className="btnAlignment" style={{ gap: "5px" }}>
                <button
                  className="btnDesign"
                  style={{ marginRight: "0.5%" }}
                  id="btnNextInfo"
                  onClick={Previous}
                >
                  Cancel
                </button>
                <button
                  className="btnDesign"
                  style={{ marginRight: "0.5%" }}
                  id="btnNextInfo"
                  onClick={handleSave}
                >
                  Save
                </button>
                { <button
                  className="btnDesign"
                  style={{ marginRight: "0.5%" }}
                  id="btnNextInfo"
                  onClick={handleSubmit}
                >
                  Create
                </button> }
              </div>
            </div>
          </div>
        </Grid>
        {/* Model for validation messages */}
                <Modal
                  open={isWarn}
                  onClose={handleCloseWarn}
                  aria-labelledby="child-modal-title"
                  aria-describedby="child-modal-description"
                >
                  <div className="modal--mask">
                    <div>
                      <Stack spacing={2} sx={{ maxWidth: 400 }}>
                        <Alert
                          variant="soft"
                          color="danger"
                          invertedColors
                          startDecorator={
                            <CircularProgress size="lg">
                              <Warning
                                variant="soft"
                                style={{ color: "#A51818 !important" }}
                              />
                            </CircularProgress>
                          }
                          sx={{ alignItems: "flex-start", "--Alert-gap": "1rem" }}
                        >
                          <Box sx={{ flex: 1 }}>
                            <Typography sx={{ mt: 1 }}>There was a problem.</Typography>
                            <br />
                            <p level="body3" style={{ textDecoration: "none" }}>
                              <p dangerouslySetInnerHTML={{ __html: isWarnMsg }}></p>
                            </p>
        
                            <Box
                              sx={{
                                mt: 2,
                                display: "flex",
                                justifyContent: "flex-end",
                                gap: 1,
                              }}
                            >
                              <Button
                                variant="soft"
                                size="sm"
                                style={{ border: "1px solid", borderRadius: "20px" }}
                                onClick={handleCloseWarn}
                              >
                                Okay
                              </Button>
                            </Box>
                          </Box>
                        </Alert>
                      </Stack>
                    </div>
                  </div>
                </Modal>
                {/* Model for Success message */}
                <Modal
                  open={isSuccess}
                  onClose={handleCloseSuccess}
                  aria-labelledby="child-modal-title"
                  aria-describedby="child-modal-description"
                >
                  <div className="modal--mask">
                    <div>
                      <Stack spacing={2} sx={{ maxWidth: 400 }}>
                        <Alert
                          color="success"
                          variant="soft"
                          invertedColors
                          startDecorator={
                            <AspectRatio
                              variant="solid"
                              ratio="1"
                              sx={{
                                minWidth: 40,
                                borderRadius: "50%",
                                boxShadow: "0 2px 12px 0 rgb(0 0 0/0.2)",
                              }}
                            >
                              <div>
                                <Check fontSize="xl2" />
                              </div>
                            </AspectRatio>
                          }
                          endDecorator={
                            <IconButton
                              variant="plain"
                              sx={{
                                "--IconButton-size": "32px",
                                transform: "translate(0.5rem, -0.5rem)",
                              }}
                            ></IconButton>
                          }
                          sx={{ alignItems: "flex-start", overflow: "hidden" }}
                        >
                          <Box sx={{ flex: 1 }}>
                            <Typography level="title-lg">Success</Typography>
                            <br />
                            <p level="body3" style={{ textDecoration: "none" }}>
                              <p dangerouslySetInnerHTML={{ __html: isSuccessMsg }}></p>
                            </p>
        
                            <Box
                              sx={{
                                mt: 2,
                                display: "flex",
                                justifyContent: "flex-end",
                                gap: 1,
                              }}
                            >
                              <Button
                                variant="soft"
                                size="sm"
                                style={{ border: "1px solid", borderRadius: "20px" }}
                                onClick={handleCloseSuccess}
                              >
                                Okay
                              </Button>
                            </Box>
                            <LinearProgress
                              variant="soft"
                              value={40}
                              sx={(theme) => ({
                                position: "absolute",
                                bottom: 0,
                                left: 0,
                                right: 0,
                                color: `rgb(${theme.vars.palette.success.lightChannel} / 0.72)`,
                                "--LinearProgress-radius": "0px",
                              })}
                            />
                          </Box>
                        </Alert>
                      </Stack>
                    </div>
                  </div>
                </Modal>
                {/* Model for loader */}
                <Modal
                  open={isLoading}
                  onClose={handleCloseWarn}
                  aria-labelledby="child-modal-title"
                  aria-describedby="child-modal-description"
                >
                  <div className="modal--mask">
                    <div>
                      <Stack spacing={2} sx={{ maxWidth: 400 }}>
                        <Alert
                          color="neutral"
                          variant="solid"
                          invertedColors
                          startDecorator={
                            <CircularProgress size="md"></CircularProgress>
                          }
                          sx={{ alignItems: "flex-start", "--Alert-gap": "1rem" }}
                        >
                          <Box sx={{ flex: 1 }}>
                            <Typography sx={{ mt: 1 }}>Submitting...</Typography>
                          </Box>
                        </Alert>
                      </Stack>
                    </div>
                  </div>
                </Modal>
                <Modal
        open={isInfo}
        onClose={handleCloseFileyProject}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <div className="modal--mask">
          <div>
            <Stack spacing={2} sx={{ maxWidth: 400 }}>
              <Alert
                variant="soft"
                color="danger"
                invertedColors
                startDecorator={null} // Remove the warning icon
                sx={{
                  alignItems: "flex-start",
                  "--Alert-gap": "1rem",
                  backgroundColor: "white", // Set background to white
                  color: "black", // Set text color to black
                }}
              >
                <Box sx={{ flex: 1 }}>
                  <Typography sx={{ mt: 1, color: "black" }}>
                  Alert
                  </Typography>
                  <br />
                  <p
                    level="body3"
                    style={{
                      textDecoration: "none",
                      color: "black", // Ensure text is black
                    }}
                  >
                    <span
                      dangerouslySetInnerHTML={{ __html: isInfoMsg }}
                    ></span>
                  </p>

                  <Box
                    sx={{
                      mt: 2,
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: 1,
                    }}
                  >
                    <Button
                      variant="soft"
                      size="sm"
                      sx={{
                        border: "1px solid",
                        borderRadius: "20px",
                        color: "black", // Button text color
                        borderColor: "black", // Button border color
                      }}
                      onClick={handleCloseFileyProject}
                    >
                      Ok
                    </Button>
                  </Box>
                </Box>
              </Alert>
            </Stack>
          </div>
        </div>
      </Modal>
      </Box>
    </div>
  );
};
export default Projectrestriction;
